import { resetPasswordMutation } from "@/admin/vm/vmQuery.ts";
import type { GQVmItem } from "@/admin/vm/VmsTable.tsx";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { WModal, WModalContent } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { VmResetPasswordBody, VmResetPasswordResponse } from "@warrenio/api-spec/spec.oats.gen";
import { notNull } from "@warrenio/utils/notNull";

interface ResetPasswordBlockModalProps {
    item: Pick<GQVmItem, "uuid">;
    location: string;
    onChange: (value: VmResetPasswordResponse | undefined) => void;
}

function ResetPasswordBlockModalContent({ item, location, onChange }: ResetPasswordBlockModalProps) {
    const resetMutation = useStandardMutation(resetPasswordMutation);

    const { uuid } = item;

    async function onSubmit() {
        const body: VmResetPasswordBody = {
            uuid,
        };
        const response = await resetMutation.mutateAsync({ body, location: notNull(location) });

        onChange(response);
    }

    return (
        <WModalContent
            title="Reset and Generate Password"
            label="Reset"
            autoFocus
            modalAction={async () => {
                await onSubmit();
            }}
        >
            <p>Warning, user password will be reset, they might not be able to log in anymore!</p>
        </WModalContent>
    );
}

export function ResetPasswordBlock(props: ResetPasswordBlockModalProps) {
    return (
        <WModal button={<WModalButton label="Reset" size="md" />}>
            <ResetPasswordBlockModalContent {...props} />
        </WModal>
    );
}
